import { Action } from 'store/store.props';
import { FILTER, SORTING } from '../actions/session_storage_action';

const initialState = {
  filters: {},
  sorting: {}
};

export const sessionStorageReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case FILTER:
      return { ...state, filters: action.payload };

    case SORTING:
      return { ...state, sorting: action.payload };

    default:
      return state;
  }
};
